// extracted by mini-css-extract-plugin
export default {"options":"Options_options__-OzVt","iconWrapper":"Options_iconWrapper__Wi7lM"};